// modules
import account from './account/index'
import config from './config/index'
import timer from './timer/index'
import env from './env/index'
import laxin from './laxin/index'
import share from './share/index'
import reddot from './reddot/index'

export default {
    account,
    config,
    timer,
    env,
    laxin,
    share,
    reddot
}
